// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cp-help-tip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 0 0 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
  color: var(--primary-color);
  font-size: 14px;
}
.cp-help-tip:hover, .cp-help-tip:focus-visible {
  color: var(--primary-color-hover, var(--primary-color));
}
.cp-help-tip:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
  border-radius: 50%;
}
.cp-help-tip i {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/components/help-tip/help-tip.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,eAAA;AACJ;AACI;EAEI,uDAAA;AAAR;AAGI;EACI,uCAAA;EACA,mBAAA;EACA,kBAAA;AADR;AAII;EAAI,oBAAA;AADR","sourcesContent":[".cp-help-tip {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0 0 0 6px;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    line-height: 1;\n    color: var(--primary-color);\n    font-size: 14px;\n\n    &:hover,\n    &:focus-visible {\n        color: var(--primary-color-hover, var(--primary-color));\n    }\n\n    &:focus-visible {\n        outline: 2px solid var(--primary-color);\n        outline-offset: 2px;\n        border-radius: 50%;\n    }\n\n    i { pointer-events: none; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
